module.exports = __webpack_public_path__ + "img/921.899e2294.gif";